import { Reveal, Eyebrow } from "./Reveal";
import { LOUNGES, LOUNGE_TIERS } from "../../data/site";
import { useBooking } from "./BookingModal";
import { useLang } from "../../i18n/LanguageContext";

export const Lounges = () => {
  const { openBooking } = useBooking();
  const { t } = useLang();
  return (
    <section
      id="lounges"
      data-testid="lounges-section"
      className="py-24 md:py-36 bg-secondary/40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <Eyebrow>{t.lounges.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5 max-w-xl leading-tight">
              {t.lounges.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <button
              data-testid="lounges-reserve"
              onClick={openBooking}
              className="text-sm uppercase tracking-luxe text-primary border-b border-primary pb-1 hover:text-accent hover:border-accent transition-colors"
            >
              {t.common.reserve}
            </button>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {LOUNGES.map((l, i) => {
            const card = t.lounges.cards[i] || l;
            return (
              <Reveal key={i} delay={i * 0.12} className="group">
                <div data-testid={`lounge-card-${i}`} className="overflow-hidden">
                  <img
                    src={l.img}
                    alt={`${card.title} – Tribe Beach Lounge, Tigaki, Kos`}
                    className="w-full h-[360px] md:h-[440px] object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <h3 className="font-serif text-2xl md:text-3xl mt-6">{card.title}</h3>
                <p className="mt-3 text-muted-foreground font-light leading-relaxed">
                  {card.desc}
                </p>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-16 bg-background border border-border p-8 md:p-10">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-md">
              <span className="inline-flex items-center bg-accent text-accent-foreground text-xs uppercase tracking-luxe px-4 py-2">
                {t.lounges.badge}
              </span>
              <h3 className="font-serif text-2xl md:text-3xl mt-5">
                {t.lounges.freeTitle}
              </h3>
              <p className="mt-3 text-muted-foreground font-light leading-relaxed">
                {t.lounges.freeDesc}
              </p>
            </div>
            <div className="grid sm:grid-cols-3 gap-4 lg:gap-6">
              {LOUNGE_TIERS.map((tier, i) => {
                const tt = t.lounges.tiers[i] || tier;
                return (
                  <div
                    key={i}
                    data-testid={`lounge-tier-${i}`}
                    className="border border-border p-5 text-center bg-secondary/30"
                  >
                    <div className="font-serif text-xl md:text-2xl font-semibold text-foreground">
                      {tt.size}
                    </div>
                    <div className="text-[11px] uppercase tracking-luxe text-accent font-medium mt-4">
                      {t.lounges.sunbedFree}
                    </div>
                    <div className="font-serif text-3xl md:text-4xl text-primary mt-1 leading-none">
                      {tier.min}
                    </div>
                    <div className="text-[11px] uppercase tracking-wider text-muted-foreground mt-1">
                      {t.lounges.minSpend}
                    </div>
                    <div className="text-sm text-foreground/70 mt-4 pt-3 border-t border-border">
                      {tt.guests}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
